import {connect} from 'react-redux'

import {QuickChat} from './quickchat.component'
import {chatSend} from '../../chat/chat.action'
import userUtil from '../../util/user.util'


const mapStateToProps = (state) => {
    return {
        currentUser: userUtil.getCurrentUser(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChatSend: (trip_id, message, sender_user_id, hashtag, mentions, created_at) => {
            dispatch(chatSend(trip_id, message, sender_user_id, hashtag, mentions, created_at))
        }
    }
}

const QuickChatContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickChat)

export default QuickChatContainer
